/*
  Swaps the add-to-cart button for the Amp back-in-stock trigger (#BIS_trigger)
  when the selected variant is sold out.

  Liquid renders the correct state for the initial variant; this handles later
  variant changes, because product-info.js only toggles the submit button's
  disabled state and never re-renders the buy-buttons markup.
*/
(() => {
  const trigger = document.getElementById('BIS_trigger');
  if (!trigger) return;

  const buttons = trigger.closest('.product-form__buttons');
  const submitButton = buttons?.querySelector('[type="submit"]');
  if (!submitButton) return;

  const render = (soldOut, variantId) => {
    if (variantId) trigger.dataset.variantId = variantId;
    trigger.classList.toggle('!tw-hidden', !soldOut);
    submitButton.classList.toggle('!tw-hidden', soldOut);
  };

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const { variant } = data;
    if (!variant) return;
    // product-info.js has already applied the disabled state by this point, so
    // it also covers sold-out-by-quantity-rule, which `available` misses.
    render(variant.available === false || submitButton.hasAttribute('disabled'), variant.id);
  });

  // An option combination with no matching variant never publishes
  // variantChange — product-info.js calls setUnavailable() and bails. It does
  // clear the variant input first, so fall back to that.
  buttons.closest('form')?.querySelector('input[name="id"]')?.addEventListener('change', ({ target }) => {
    if (!target.value) render(false);
  });
})();
